var Text = {
  plural: function(n, forms) {
    var plural = 0;
    if (n % 10 == 1 && n % 100 != 11) {
      plural = 0;
    } else {
      if ((n % 10 >= 2 && n % 10<=4) && (n % 100 < 10 || n % 100 >= 20)) {
        plural = 1;
      } else {
        plural = 2;
      }
    }

    return forms[plural];
  }
};